<template>
  <div class="">
    <div class="actor-info" v-if="isDone">
      <div class="">
        <div class="container mx-auto px-4 pt-10 flex flex-col md:flex-row border-b border-gray-800 pb-10">
          <div class="flex-none">
            <img :src="imagePath(actorDetail.profile_path)"
                 alt="actor image" class="w-64 lg:w-96 rounded">
            <div class="mt-4" v-if="socialData.facebook_id">
              <a :href="'https://www.facebook.com/'+socialData.facebook_id" target="_blank" class="hover:underline hover:text-gray-400">
                <i class="fa-brands fa-facebook-square mr-1"></i> {{socialData.facebook_id}}
              </a>
            </div>
          </div>
          <div class="md:ml-14">
            <h2 class="font-semibold
                  uppercase tracking-wide
                  mt-4 md:mt-0 text-4xl">{{ actorDetail.name }}</h2>
            <div class="text-gray-400 text-sm space-y-2 mt-2">
              <i class="fa-solid fa-cake-candles mr-1"></i>{{ actorDetail.birthday }}
              <div class="">
                <i class="fa-solid fa-location-arrow mr-1"></i>{{ actorDetail.place_of_birth}}
              </div>
              <div class="">
                <i class="fa-solid fa-star text-orange-500 mr-1"></i> {{ Math.ceil(actorDetail.popularity/10)}}%
              </div>
            </div>
            <p class="text-gray-300 mt-12">
              {{ actorDetail.biography }}
            </p>
          </div>
        </div>
      </div>
      <div class="mt-10">
        <div class="container mx-auto px-4 border-b border-gray-800 pb-10">
          <h2 class="font-semibold text-2xl mb-6 text-orange-500">Known For</h2>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 gap-x-px -mx-4">
            <div class="mt-4 px-3" v-for="credit in credits.cast" :key="credit.id">
              <router-link :to="{name: 'detail', params: {id: credit.id}}" class="">
                <img :src="creditImagePath(credit.poster_path)" alt="" class="">
              </router-link>
              <router-link :to="{name: 'detail', params: {id: credit.id}}" class="text-wrap text-gray-400" v-if="credit.original_title">{{ credit.original_title }}</router-link>
              <router-link :to="{name: 'detail', params: {id: credit.id}}" class="text-gray-400" v-else>{{ credit.original_name }}</router-link>
              <div class="mt-1" v-if="Math.ceil(credit.vote_average) > 0">
                <i class="fa-solid fa-star text-orange-500 mr-1"></i> {{ Math.ceil(credit.vote_average)}}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto px-4" v-else>
      <div class="flex justify-center items-center min-h-screen pb-28 lg:pb-16">
        <img src="../assets/loading.gif" alt="loading" class="w-80">
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ActorDetailView",
  data() {
    return {
      actorDetail: [],
      socialData:{},
      credits: [],
      isDone: false,
    }
  },
  methods: {
    imagePath(image) {
      if (image){
        return  'https://image.tmdb.org/t/p/w500/'+image;
      }
    },
    creditImagePath(image) {
      if (image){
        return  'https://image.tmdb.org/t/p/w185/'+image;
      }else {
        return 'https://via.placeholder.com/185x278';
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
    axios.get(`https://api.themoviedb.org/3/person/${this.id}`,{
      headers: {"Authorization" : `Bearer ${token}`}
    })
    .then(res => {
      this.actorDetail = res.data;
    })
    .catch(error => console.log(error));

    axios.get(`https://api.themoviedb.org/3/person/${this.id}/external_ids`,{
      headers: {"Authorization" : `Bearer ${token}`}
    })
    .then(res => {
      this.socialData = res.data;
    })
    .catch(error => console.log(error));

    axios.get(`https://api.themoviedb.org/3/person/${this.id}/combined_credits`,{
      headers: {"Authorization" : `Bearer ${token}`}
    })
    .then(res => {
      this.credits = res.data;
    })
    .catch(error => console.log(error));
    setTimeout(() => {
      this.isDone = true;
    }, 2500);
  }
}
</script>

<style scoped>

</style>